import type { TranslationMessages } from '../../types';

export const header: TranslationMessages = {
  title: 'My Neko',
  subtitle: 'Your personal dashboard for work, rewards, and growth',
};
